import { render, staticRenderFns } from "./SlidePage4.vue?vue&type=template&id=ba053e54&scoped=true&"
import script from "./SlidePage4.vue?vue&type=script&lang=js&"
export * from "./SlidePage4.vue?vue&type=script&lang=js&"
import style0 from "./SlidePage4.vue?vue&type=style&index=0&id=ba053e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba053e54",
  null
  
)

export default component.exports